import React from 'react';
import { CustomTabs, CustomTab } from './CustomTabComponents';
import Mileage from './Mileage_content';
import Shift_Mileage from './Shift_content';
import Intraday_Mileage from './Intraday_shift_content';
import Locations from './Locations';
const TabsComponent = ({ 
    activeTab, 
    handleTabChange,
    submitClicked,
    handleDownload,
    error={error}
    }) => {

        return (
            <div style={{ backgroundColor: 'white', marginBottom: '20px', margin: '30px 60px 60px 60px'}}>
                <div style={{ backgroundColor: 'white', paddingTop: '10px', borderRadius: '4px' }}>
                    <CustomTabs value={activeTab} onChange={handleTabChange}>
                        <CustomTab label='Shifts between break time of at least 30 minutes' />
                        <CustomTab label='Shifts between break time of at least 8 hours' />
                        <CustomTab label='Mileage' />
                        {/* <CustomTab label='Location' /> */}
                    </CustomTabs>
                </div>
                <div style={{ marginTop: '20px', backgroundColor: 'white' }}>
                <div style={{ display: activeTab === 1 ? 'block' : 'none' }}>
                    <Shift_Mileage submitClicked={submitClicked} handleDownload={handleDownload} error={error} />
                </div>
                <div style={{ display: activeTab === 2 ? 'block' : 'none' }}>
                    <Mileage submitClicked={submitClicked} handleDownload={handleDownload} error={error} />
                </div>

                <div style={{ display: activeTab === 0 ? 'block' : 'none' }}>
                    <Intraday_Mileage submitClicked={submitClicked} handleDownload={handleDownload} error={error} />
                </div>
                {/* <div style={{ display: activeTab === 3 ? 'block' : 'none' }}>
                    <Locations submitClicked={submitClicked} handleDownload={handleDownload} error={error} />
                </div> */}
                </div>

            </div>
        );
    };
    
    export default TabsComponent;





